/**
 * @generated SignedSource<<2d425785ac0ae5240d27b5bacd274c31>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type MembershipRoleKindEnumType = "admin" | "coordinator" | "general" | "%future added value";
export type MembershipUpdateInput = {
  clientMutationId?: string | null | undefined;
  membership: MembershipUpdateInputObject;
};
export type MembershipUpdateInputObject = {
  id: string;
  kind?: MembershipRoleKindEnumType | null | undefined;
};
export type UpdateMembership_Mutation$variables = {
  input: MembershipUpdateInput;
};
export type UpdateMembership_Mutation$data = {
  readonly updateMembership: {
    readonly membership: {
      readonly id: string;
      readonly kind: MembershipRoleKindEnumType | null | undefined;
    } | null | undefined;
  };
};
export type UpdateMembership_Mutation = {
  response: UpdateMembership_Mutation$data;
  variables: UpdateMembership_Mutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "MembershipUpdatePayload",
    "kind": "LinkedField",
    "name": "updateMembership",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Membership",
        "kind": "LinkedField",
        "name": "membership",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "id",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "kind",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "UpdateMembership_Mutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "UpdateMembership_Mutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "581a57c50d907c6bef0cf026726f02b9",
    "id": null,
    "metadata": {},
    "name": "UpdateMembership_Mutation",
    "operationKind": "mutation",
    "text": "mutation UpdateMembership_Mutation(\n  $input: MembershipUpdateInput!\n) {\n  updateMembership(input: $input) {\n    membership {\n      id\n      kind\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "7e848b82fd97a8fbd60571f18f0208cb";

export default node;
